import { render } from "./withdrawal.vue?vue&type=template&id=4585de1e"
import script from "./withdrawal.vue?vue&type=script&lang=js"
export * from "./withdrawal.vue?vue&type=script&lang=js"

import "./withdrawal.vue?vue&type=style&index=0&id=4585de1e&lang=css"

import exportComponent from "/home/copycrack-client-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__